import React from "react";

function PlayerFixtures(props) {
  const { fixtures, variant = "venue" } = props;

  const getTeamBadge = (teamName) => {
    if (!teamName) {
      return null;
    }

    try {
      return require(`../images/team_badges/${teamName}.svg`);
    } catch (e) {
      return null;
    }
  };

  if (!fixtures || fixtures.length === 0) {
    return null;
  }

  return (
    <span className={`player-fixtures player-fixtures-${variant}`}>
      {fixtures.map((f, index) => (
        <span
          key={`${f.Opponent || "opp"}-${index}`}
          className={`player-fixture player-fixture-variant-${variant} player-fixture-${f.Home ? "home" : "away"} player-fixture-difficulty-${f.Difficulty}`}
          title={`${f.Opponent || "Unknown"} (${f.Home ? "H" : "A"})`}
        >
          {getTeamBadge(f.Opponent) ? (
            <img
              src={getTeamBadge(f.Opponent)}
              alt={f.Opponent}
              className="player-team-badge"
            />
          ) : (
            <span className="player-fixture-fallback">{f.Opponent}</span>
          )}
          {variant === "venue" && (
            <span className="player-fixture-venue">{f.Home ? "H" : "A"}</span>
          )}
        </span>
      ))}
    </span>
  );
}

export default PlayerFixtures;
